import moment from "moment";
import { call, put, takeLatest } from "redux-saga/effects";

import { getBlocksSuccess, getBlocksFailure } from "./Blocks.actions";
import { BlocksService } from "./Blocks.store";

function delay(duration) {
  const promise = new Promise((resolve) => {
    setTimeout(() => resolve(true), duration);
  });
  return promise;
}

function* getBlocksSaga(args) {
  try {
    const { dateRange, update } = args;
    let existingBlocks = [];
    if (update) {
      while (update) {
        const blocksService = new BlocksService();
        const updatedArgs = {
          ...args,
          dateRange: [dateRange[0], moment()],
          existingBlocks,
        };
        const { data } = yield call(blocksService.fetchBlocks, updatedArgs);
        existingBlocks = data;
        yield put(getBlocksSuccess(data));
        yield call(delay, 10000);
      }
    } else {
      yield put(getBlocksSuccess([]));
    }
  } catch (error) {
    yield put(getBlocksFailure(error));
  }
}

export function* blocksSagas() {
  const GET_BLOCKS = "GET_BLOCKS";
  yield takeLatest(GET_BLOCKS, getBlocksSaga);
}
